import createAPI from '../axios'

// 课程标准相关API
const courseStandard = {
    courseStandard: {
        initCombo: config => createAPI('/Kcbzzb/initCombo', 'post', config),

        list: config => createAPI('/Kcbzzb/list', 'post', config),
    },
	KcbzKcbzzb:{
		queOne:config =>createAPI('/Kcbzzb/queOne', 'post', config),
		update:config =>createAPI('/Kcbzzb/update', 'post', config),
		findjxdg:config =>createAPI('/Kcbzzb/findjxdg', 'post', config),
		findwnkcbz:config =>createAPI('/Kcbzzb/findwnkcbz', 'post', config),
		importmsg:config =>createAPI('/Kcbzzb/importmsg', 'post', config),
		//找到云班的历史课程标准 胡杰20210818
		findHistryKcbz:config =>createAPI('/Kcbzzb/findHistryKcbz', 'post', config),
		//徐毅骏 20220120 导入前验证被导入课程与导入课程的数据
		checkBeforImport:config =>createAPI('/Kcbzzb/checkBeforImport', 'post', config),
		//导出课程标准	WHY	20210610
		export:config =>createAPI('/Kcbzzb/export', 'post', config),
        deleteFile: config => createAPI('/Kcbzzb/deleteFile', 'post', config),
        updateAuditState: config => createAPI('/Kcbzzb/updateAuditState', 'post', config),
	},
	KcbzKcnryyq:{
		queList:config =>createAPI('/Kcnryyq/queOne', 'post', config),
		queList2:config =>createAPI('/Kcnryyq/queOne2', 'post', config),
		queListByMsg:config =>createAPI('/Kcnryyq/queListByMsg', 'post', config),
		addMsg:config =>createAPI('/Kcnryyq/addMsg', 'post', config),
		deleteMsg:config =>createAPI('/Kcnryyq/deleteMsg', 'post', config),   //删除选中的知识点技能点
		addjobzsd:config =>createAPI('/Kcnryyq/addjobzsd', 'post', config),	  //新增一级知识点技能点
		findyjzsdjnd:config =>createAPI('/Kcnryyq/findyjzsdjnd', 'post', config),	  //查找所有的一级知识点或技能点
		findejzsdjnd:config =>createAPI('/Kcnryyq/findejzsdjnd', 'post', config),	  //查找所有的二级知识点或技能点
		addejzsd:config =>createAPI('/Kcnryyq/addejzsd', 'post', config),	  //新增二级知识点技能点
		findsjzsdjnd:config =>createAPI('/Kcnryyq/findsjzsdjnd', 'post', config),	  //查找所有的二级知识点或技能点
		addsjzsd:config =>createAPI('/Kcnryyq/addsjzsd', 'post', config),//新增三级知识点技能点
		editjobzsd:config =>createAPI('/Kcnryyq/editjobzsd', 'post', config),//编辑一级知识点
		editejzsd:config =>createAPI('/Kcnryyq/editejzsd', 'post', config),//编辑二级知识点
		editsjzsd:config =>createAPI('/Kcnryyq/editsjzsd', 'post', config),//编辑三级知识点
	},

	//课程标准编辑人设置	20210818 WHY
	kcbzBjrController:{
		//添加编辑人
		insertBjr:config => createAPI('/kcbzBjrController/insertBjr','post',config),
		//编辑人数据回显
		getBjrList:config => createAPI('/kcbzBjrController/getBjrList','post',config),
		//根据人查询可编辑的课程标准
		getKcbhByUser:config => createAPI('/kcbzBjrController/getKcbhByUser','post',config),
		//查询登录人是否可以编辑当前课标
		getBjrByKCBZ:config => createAPI('/kcbzBjrController/getBjrByKCBZ','post',config),
	},

}

export default courseStandard;



// WEBPACK FOOTER //
// ./src/api/modules/courseStandard.js